import { useMemo } from 'react';
import { useGetAccountsQuery } from '../../../../../redux/api/fymAPI';
import { useUserToken } from '../../../../../redux/slices/appInfo/hooks';
import { getFullAPIFileURL } from '../../../../common/getFullAPIFileURL';

/** The profile of the artist that a Spotify header shows: the name and the profile photo (Settings → Artist). */
export interface ArtistProfile {
  name: string | null;
  /** The file of the profile photo: the header can use it as its picture. Null: no photo. */
  photo: { fileId: number; url: string } | null;
  /** The small round photo of the overlay. */
  avatarUrl: string | null;
}

/** The profile of the artist `accountId`, from the accounts answer that the app reads already. */
export function useArtistProfile(accountId: number): ArtistProfile {
  const userToken = useUserToken();
  const { account } = useGetAccountsQuery(undefined, {
    skip: !userToken,
    selectFromResult: ({ data }) => ({ account: data?.accounts.find((item) => item.id === accountId) }),
  });
  return useMemo(() => {
    const file = account?.avatarFile ?? null;
    return {
      name: account?.name ?? null,
      photo: file === null ? null : { fileId: file.id, url: getFullAPIFileURL(file.url) },
      avatarUrl: file === null ? null : (account?.avatarProcessedUrl ?? getFullAPIFileURL(file.url)),
    };
  }, [account]);
}
